export const UPDATE_SETTINGS = 'UPDATE_SETTINGS';
export const updateSettings = (settings) => ({
    type: UPDATE_SETTINGS,
    payload: { settings },
});

export const SETTINGS_LOADED = 'SETTINGS_LOADED';
export const settingsLoaded = (settings) => ({
    type: SETTINGS_LOADED,
    payload: { settings },
});